module.exports = __webpack_public_path__ + "img/9788991931633.86a76a7e.jpg";